import { useEffect } from 'react'
import { AppContact } from '../components/AppContact'
import { StyledLink } from '../components/StyledLink'
import { StyledSubHeader } from '../components/StyledSubHeader'
import logo from '../eye-mask.svg'

export const SayToMe = () => {

    useEffect(()=>{
        document.title = 'SayToMe Intro'
    })

    return (
        <div className='flex-column about' >
            <img src={logo} alt="" style={{ width: 100, height: 70, marginTop: 10 }} />
            <h2>SayToMe</h2>
            <p>SayToMe is a Free Dateship platform where you can</p>
            <ol>
                <li>Get Anonymous critics as voice notes from anonymous users and..can continue the converstation on the platform.</li>
                <li>Connect with real, verified users on our Dateship service who are mutually interested.</li>
            </ol>
            <h4>Okay, We already have all of this before, what's new?</h4>
            <p>SayToMe has few additional things baked in which you won't get elsewhere..yet as follows</p>
            <ol>
                <li>You get insights as how many times you were viewed or your Voice Intro was played.</li>
                <li>You'll know how many people swiped you left/right on the Dateship platform.</li>
                <li>No weird Elo Matching algos to frustrate you. You can see how many times your profile was shown to
                    other Dateship users.
                </li>
                <li>You can be assured that all users on the platform are real and safe as we have a strict entry process.</li>
            </ol>
            <h4>And above all, We are completely <span style={{ color: 'green', fontWeight: 'bolder' }} >FREE</span>.</h4>
            <StyledSubHeader heading="How are you free? What's the catch..?" />
            <p>Glad you asked :) There's no catch. We have a small Digital infrastructure footprint for now which can be borne by
                the Creators. However, when it grows big we would turn to our generous wealthy users for donations :)
            </p>
            <StyledSubHeader heading="What if you don't get Donations?" />
            <p>In that case, we will try expand as much as possible with existing resources and would have to limit new user registrations.</p>
            <i>We intend to keep the platform Clean, Safe and Free</i>
            <div className='flex-column' style={{ width: '100%' }} >
                <h3>Links</h3>
                <StyledLink heading='Home' path='/' />
                <StyledLink heading='Sign Up' path='/stapp/register' />
                <StyledLink heading='What is SayToMe?' path='/stapp/about' />
                <StyledLink heading='Why Invite codes?' path='/stapp/needforinvite' />
            </div>
            <AppContact/>
            <img src={logo} alt="" style={{ width: 40, height: 30, marginTop: 10 }} />
        </div>
    )
}